import { FC } from "react";
import { useTheme } from "styled-components";
import { useGetCitiesAssets } from "contexts/AssetsContext";
import { ICityLiteAsset } from "models/Assets/ICityAsset";
import { classNames, labelHelper } from "helpers/themeHelpers";
import IconLocation from "assets/icons/IconLocation";
import useGetCountry from "hooks/useGetCountry";
import useGetRouteCity from "hooks/useGetRouteCity";
import { useRouter } from "next/router";
import NativeAutoComplete from "componentReusable/UIComponents/Form/NativeAutoComplete";
import { IItemCommon } from "models/base/Generics";
import { linkToHome } from "helpers/links-builders/home";
import { IGoToFindParams } from "models/header";
import {destroyCookie, setCookie} from "utils/nookies";
import {CookiesConstants} from "utils/constants";

interface IProps {
  cityPlaceHolder?: string;
  goToFind?: (newQuery: IGoToFindParams) => void;
}

const CitiesSearchField: FC<IProps> = ({ goToFind }) => {
  const router = useRouter();
  const { translations } = useTheme();
  const city = useGetRouteCity();
  const cities = useGetCitiesAssets<ICityLiteAsset>(true);
  const country = useGetCountry();

  function renderOption(option: ICityLiteAsset, onClick: (e: any) => void) {
    return (
      <li key={option.id} onClick={onClick}>
        <a
          {...classNames(
            "p-16 pointer grayHoverBg blackColor block ",
            option.id === -2 && "linkColor"
          )}
          onClick={(e) => e.preventDefault()}
          href={linkToHome(option)}
        >
          {labelHelper(option)}
        </a>
      </li>
    );
  }

  return (
    <NativeAutoComplete
      parentContainerClass="citiesDropDown"
      placeholder={
        labelHelper(country) +
        " - " +
        translations.mobileFilter.allCities
      }
      inputWithBorder={false}
      dropdownIcon={<IconLocation fill="#000" />}
      getOptionLabel={labelHelper}
      options={cities}
      renderOption={renderOption}
      selectedItem={city}
      onSelect={(item: IItemCommon) => {
        switch (item.id) {
          case 0:
            //do nothing, just clear the cookies
            destroyCookie(null, CookiesConstants.CITY_ID);
            window.location.href=linkToHome();
            break;
          default:
            goToFind && goToFind({ city: item });
            setCookie(null, CookiesConstants.CITY_ID, `${item.id}`);
            break;
        }
      }}
    />
  );
};

export default CitiesSearchField;
